import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { appStorage, createUUID, sortOnField } from "@miplatform/utils";

const getRoleUUID = createUUID();
const updateRoleUUID = createUUID();

export function useRoleDetailsViewModel() {
  const [permissions, setPermissions] = useState([]);
  const [assignedPermissions, setAssignedPermissions] = useState([]);
  const [role, setRole] = useState({});

  const stateManager = useComponentState();

  const getUserRoleAndAllPermissions = (id) => {
    stateManager.abort(getRoleUUID);
    stateManager.run(async () => {
      const roleResponse = await subscriptionService.roles.get(id);
      const permissionsResponse =
        await subscriptionService.permissions.getAll();

      if (
        roleResponse.status === HTTP_STATUSES.OK &&
        permissionsResponse.status === HTTP_STATUSES.OK
      ) {
        const responseOrder = permissionsResponse?.data
          .filter((e) => !roleResponse.data?.permissionNames.includes(e.name))
          .sort(sortOnField("name"));

        const permissionsOrdered = roleResponse.data.permissionNames
          .sort(sortOnField("name"))
          .map((item) => ({ name: item }));

        setRole({
          ...roleResponse.data,
          permissionNames: permissionsOrdered,
          availablePermissions: responseOrder,
        });

        setPermissions(responseOrder);
        setAssignedPermissions(permissionsOrdered);
      }
    }, getRoleUUID);
  };

  const updateRole = (id, data) => {
    stateManager.abort(updateRoleUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.roles.update({
        id,
        data,
        toastMessageConfig: {
          success: {
            text: `Role updated successfully.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        if (process.env.BYPASS_AUTH) {
          const oid = process.env.LOCAL_USER_ID;
          const domain = process.env.LOCAL_DOMAIN;
          const { data: userData } = await subscriptionService.userProfile.get(
            oid,
            domain
          );
          const permissions = userData.permissions.join(",");
          appStorage.setItem("permissions", permissions);
        }
        return response.data;
      }
      return null;
    }, updateRoleUUID);
  };

  return {
    permissions,
    setPermissions,
    assignedPermissions,
    getUserRoleAndAllPermissions,
    setAssignedPermissions,
    updateRole,
    stateManager,
    role,
  };
}
